import moment from 'moment';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SingleFieldList,
  ChipField,
  ArrayField,
  Filter,
  SelectInput,
  DateField,
  SelectField,
  DateInput,
} from 'react-admin';

import { CustomActions, CustomReferenceInput, DownloadButtonReceipt } from '../../../components';
import { orderSourceAddressChoice, statusOrderChoice } from '../../../constants/choices';
import { ListPagination, downloadCsv } from '../../../utils';
import DeleteOrderButton from './Components/DeleteOrderButton';

const SENT_STATUS_ID = statusOrderChoice.find(c => c.name === 'Enviado')?.id;

const OrderFilter = props => (
  <Filter {...props}>
    <TextInput label="AR" source="id" alwaysOn />
    <TextInput label="Ciclo" source="cycleId" alwaysOn />
    <TextInput label="Painel" source="panel.name" alwaysOn />
    <TextInput label="Documento" source="user.document" />

    <CustomReferenceInput source="cycle.labId" label="Laboratório" reference="labs" />
    <CustomReferenceInput source="cycle.campaignId" label="Campanha" reference="campaigns" />
    <CustomReferenceInput source="campaign.projectId" label="Projeto" reference="projects" />

    <SelectInput source="statusOrderId" label="Status" choices={statusOrderChoice} optionText="name" optionValue="id" />

    <DateInput label="Criados a partir de" source="createdAt.gte" />
    <DateInput label="Criados até" source="createdAt.lte" />
  </Filter>
);

const exporter = (data) => {
  const dataForExport = data.map(item => ({
    AR: item?.id,
    Ciclo: item.cycle?.id ?? '',
    Documento: item.user?.document ?? '',
    Laboratórios: item.labsList?.map(i => i.lab) ?? '',
    'Tipo de Documento': item.user?.typeUser?.name ?? '',
    'Conteúdo do Kit': item.samplesList?.map(i => i.sample).join(', ') ?? '',
    'Data de Criação': moment(item.createdAt).format('DD/MM/YYYY'),
    'Última Atualização': moment(item.updatedAt).format('DD/MM/YYYY'),
    'Status': statusOrderChoice.find(({ id }) => id === item.status)?.name ?? '',
    'Origem do Endereço': orderSourceAddressChoice.find(({ id }) => id === item.addressSourceId)?.name ?? '',
    Painel: item.panel?.name ?? '',
    Nome: item.user?.name ?? '',
    Sobrenome: item.user?.lastName ?? '',
    CPF: item.user?.cpf ?? '',
    Email: item.user?.email ?? '',
    Telefone: item.user?.phone ?? '',
    Rua: item.address?.address ?? '',
    Número: item.address?.number ?? '',
    Complemento: item.address?.complement ?? '',
    CEP: item.address?.cep ?? '',
    Bairro: item.address?.district ?? '',
    Cidade: item.address?.city ?? '',
    UF: item.address?.state ?? '',
  }));

  const csv = convertToCSV({
    data: dataForExport,
    fields: ['AR', 'Ciclo', 'Documento', 'Laboratórios', 'Tipo de Documento', 'Conteúdo do Kit', 'Data de Criação', 'Última Atualização', 'Status', 'Origem do Endereço', 'Painel', 
      'Nome', 'Sobrenome', 'CPF', 'Email', 'Telefone', 'Rua', 'Número', 'Complemento', 'Bairro', 'Cidade', 'UF', 'CEP'],
  }, { delimiter: ';' });

  const filename = `Extracao_Pedidos_${moment().format('YYYYMMDD')}`;
  downloadCsv(csv, filename);
};

const OrderBulkActionButtons = (props) => (
  <DeleteOrderButton
    basePath="/orders"
    record={props.data}
    resource={props.resource}
    {...props}
  />
);

const OrderList = (props) => (
  <List
    resource="orders"
    basePath="/orders"
    perPage={25}
    title="Lista de Pedidos"
    hasCreate={true}
    actions={<CustomActions />}
    exporter={exporter}
    filters={<OrderFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid
      resource="orders"
      rowClick="edit"
      bulkActionButtons={<OrderBulkActionButtons />}
      isRowSelectable={
        record => record?.status === SENT_STATUS_ID
        && record?.deliveryDate === null 
        && (record?.receipt === null || record?.receipt === '')
      }
    >
      <TextField label="AR" source="id" />
      <TextField label="Ciclo" source="cycle.id" />
      <TextField sortable={false} label="Documento" source="user.document" />
      <TextField sortable={false} label="Tipo de Documento" source="user.typeUser.name" />
      <ArrayField sortable={false} label="Conteúdo do Kit" source="samplesList">
        <SingleFieldList>
          <ChipField source="sample" />
        </SingleFieldList>
      </ArrayField>
      <ArrayField sortable={false} label="Laboratórios" source="labsList">
        <SingleFieldList>
          <ChipField source="lab" />
        </SingleFieldList>
      </ArrayField>
      <ChipField sortable={false} label="Painel" source="panel.name" />
      <TextField sortable={false} label="Projeto" source="cycle.campaign.project.name" />
      <TextField sortable={false} label="Campanha" source="cycle.campaign.name" />
      <DateField label="Data de Criação" source="createdAt" />
      <DateField label="Última Atualização" source="updatedAt" />
      <ArrayField label="Comprovante">
        <DownloadButtonReceipt route='orders/receipts' />
      </ArrayField>
      <SelectField sortable={false} label="Status" source="status" choices={statusOrderChoice} optionText="name" optionValue="id" />
      <SelectField
        label="Origem do Endereço"
        source="addressSourceId"
        choices={orderSourceAddressChoice}
      />
    </Datagrid>
  </List>
);

export default OrderList;
